export const tableActionTypes = {
  resetSelectedItems: '[Table] - reset selected items in table',
};
